export default __webpack_public_path__ + "static/media/office.7688d6b8.jpg";